
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Help from "@/templates/Help/Help"

function Delivery() {
  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <h2 className="text-xl font-medium">Metody i czas dostawy</h2>
      <div className="max-w-3xl mt-10 space-y-6 text-sm text-black text-opacity-80">
        <p>
          Produkty z fansi Kolekcji są dostarczane przez następujące firmy
          kurierskie: kurier DPD, kurier DHL, kurier FedEx oraz kurier UPS.
        </p>
        <p>Zamówienia powyżej 400 zł objęte są darmową dostawą.</p>
        <p>
          Czas przygotowania do wysyłki zamówienia z fansi Kolekcji zajmuje ok.
          2-3 dni roboczych, dostawa za pośrednictwem firmy kurierskiej zajmuje
          ok. 2 dni roboczych.
        </p>
        <p>
          Jeżeli nie otrzymałeś/aś swojej przesyłki w oczekiwanym terminie,
          napisz do nas na{" "}
          <a
            href="mailto:info@fansi.pl"
            className="text-violet-150 hover:underline"
          >
            info@fansi.pl.
          </a>
        </p>
        <p>
          Po zakupie, możesz w każdej chwili sprawdzić status swojego zamówienia
          w zakładce Zamówienia. Dodatkowo będziemy Cię informować o każdej
          zmianie statusu za pośrednictwem wiadomości e-mail.
        </p>
        <p>
          Po przekazaniu przez nas przesyłki do firmy transportowej, otrzymasz
          wiadomość e-mail wraz z linkiem trackującym, dzięki któremu będziesz
          mógł/a śledzić swoje zamówienie.
        </p>
        <p>
          Produkty z pozostałych kategorii fansi (innych niż Kolekcje) są
          dostarczane w formie cyfrowej, za pomocą platformy. Jeżeli chcesz
          sprawdzić status swojego zamówienia, przejdź do zakładki{" "}
          <span className="font-medium">Zamówienia</span>.
        </p>
      </div>
    </>
  )
}

Delivery.Layout = Help

export default Delivery


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/delivery',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  